import { useEffect, useState } from 'react';
import './GlobalErrorModal.css';

export default function GlobalErrorModal() {
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const handleGlobalError = (event) => {
            if (event.target && (event.target.tagName === 'IMG' || event.target.tagName === 'SCRIPT' || event.target.tagName === 'LINK')) {
                return;
            }

            console.error("Global Error Caught:", event);
            const msg = event.message || event.error?.message || (typeof event === 'string' ? event : "Si è verificato un errore imprevisto.");
            setErrorMessage(msg);
            setHasError(true);
        };

        const handlePromiseRejection = (event) => {
            console.error("Unhandled Promise Rejection Caught:", event.reason);
            if (event.reason && event.reason.name === 'AbortError') return;

            setErrorMessage(event.reason?.message || "Errore di connessione o risorsa non trovata.");
            setHasError(true);
        };

        const handleCustomAppError = (event) => {
            setErrorMessage(event.detail || "Si è verificato un errore nell'applicazione.");
            setHasError(true);
        };

        window.addEventListener('error', handleGlobalError, true);
        window.addEventListener('unhandledrejection', handlePromiseRejection, true);
        window.addEventListener('app-error', handleCustomAppError, true);

        return () => {
            window.removeEventListener('error', handleGlobalError, true);
            window.removeEventListener('unhandledrejection', handlePromiseRejection, true);
            window.removeEventListener('app-error', handleCustomAppError, true);
        };
    }, []);

    if (!hasError) return null;

    return (
        <div className="global-error-overlay">
            <div className="global-error-modal">
                <div className="global-error-icon">⚠️</div>
                <h2>Oops! Qualcosa è andato storto.</h2>
                <p>{errorMessage}</p>
                <button 
                    className="global-error-refresh-btn" 
                    onClick={() => window.location.reload()}
                >
                    Aggiorna la pagina
                </button>
            </div>
        </div>
    );
}
